module.exports = __webpack_public_path__ + "static/first_slider-863e3fbccce128d1d047f4dbb2bb4ed7.png";